<div class="loading-indicator" aria-label="Loading">
  <div class="loading-indicator-spinner"></div>
</div>
